import MemoryCacheDriver from '@/cache/driver/mem'

export default class Cache {
  driver

  constructor (driver) {
    this.driver = driver
  }

  static defaultCache () {
    return Cache.memoryCache()
  }

  static memoryCache () {
    return new Cache(new MemoryCacheDriver())
  }

  /**
   * Cache a promise returned by promiseFunc. If the key is not found, promiseFunc is called and the resulting promise
   * is stored in the cache and returned. If the key is found, the cached promise is returned.
   *
   * @param {string|array} key
   * @param {function(): Promise<*>} promiseFunc
   */
  async promise (key, promiseFunc) {
    if (this.has(key)) {
      return this.get(key)
    }
    const promise = promiseFunc()
    await this.set(key, promise)
    return promise
  }

  has (key) {
    return this.driver.has(key)
  }

  async get (key) {
    return this.driver.get(key)
  }

  async set (key, value) {
    this.driver.set(key, value)
  }

  async reset () {
    this.driver.reset()
  }

  async resetKey (key) {
    await this.driver.resetKey(key)
  }
}
